import { Box } from '@wix/design-system';
import React from 'react';
export const RuleLayout = _ref => {
  let {
    description,
    children,
    design
  } = _ref;
  const appliedGap = (design == null ? void 0 : design.gap) ?? 'SP2';
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: appliedGap,
    width: "100%"
  }, description, children);
};
//# sourceMappingURL=rule-layout.js.map